import React from 'react'

const footer = () => {
  return (
    <>
      <div className="flex justify-center items-center">
        <p>Made with ❤️ by <span className='text-green-500 font-bold'><a href="https://itzabhinavarya.netlify.app">Abhinav Arya</a></span></p>
      </div>
    </>
  )
}

export default footer
